import type { FunctionComponent } from "react";
import { Table, TableHeaderColumn } from "@kanda-libs/ks-component-ts";
import useLoanTableProps from "components/loan/LoanTable/useLoanTableProps";
import { TABLE_COLUMNS } from "components/loan/LoanTable/constants";

export interface LoanTableProps {}

const LoanTable: FunctionComponent<LoanTableProps> = function () {
  const props = useLoanTableProps();

  return (
    <Table
      {...props}
      columns={TABLE_COLUMNS as unknown as TableHeaderColumn[]}
    />
  );
};

export default LoanTable;
